import React from 'react';
import { SwipeableDrawer, Typography, Box, List, ListItem, ListItemText } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import LoadingPageText from '../../../../components/common/Loading/LoadingPageText';

import { useAppointmentDetails } from '../../../../actions/areas/admin/fetchHooks/fetchExternalProvider';
import { parseShortDateWithTime } from '../../../../utils/dates';
import useTeamProvider from '../useTeamProvider';
import { ExternalProviderType } from '../../../../enums';
import globals from '../../../../globals/communityGlobals';

const locale = globals.getAreas(['externalProvider', 'userActions']);

export default function AssignmentDetailsSidePanel() {
  const { selectedAppointment, assignmentId, patientInfo, handleDetailsSidePanel } = useTeamProvider();

  const { data, isDataLoading } = useAppointmentDetails(
    { AppointmentId: selectedAppointment, AssignmentId: assignmentId },
    false,
  );

  const isRioExternalProvider = data.externalProviderType === ExternalProviderType.Rio;
  const isSystmOneExternalProvider = data.externalProviderType === ExternalProviderType.SystmOne;

  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer anchor="right" open onOpen={() => {}} onClose={() => {}}>
        <div className="sidePanel-wrapper" style={{ width: '500px' }}>
          <div className="sidePanel-header form-header">
            <div className="sidePanel-header-subtitle">
              <Box display="flex">
                <Box flexGrow={1} py={1}>
                  <Typography variant="subtitle1">{locale.getMsg('appointmentDetails')}</Typography>
                </Box>
                <Box>
                  <IconButton onClick={() => handleDetailsSidePanel(false)}>
                    <CancelIcon />
                  </IconButton>
                </Box>
              </Box>
            </div>
          </div>
          {isDataLoading && (
            <LoadingPageText showHeader={false}>
              {locale.getMsg('loadingMsg', [locale.getMsg('appointmentDetails')])}
            </LoadingPageText>
          )}
          {data.appointment && (
            <div className="sidePanel-content content-top-padding">
              <div className="clinician-info-box">
                <Typography variant="h6" gutterBottom>
                  {locale.getMsg('appointmentDetails')}
                </Typography>
                <List className="list-underline">
                  <ListItem key="patientInfo">
                    <ListItemText primary="Patient" />
                    <span className="divider" />
                    <ListItemText secondary={patientInfo} />
                  </ListItem>
                  <ListItem key="start date and time">
                    <ListItemText primary="Start date and time" />
                    <span className="divider" />
                    <ListItemText secondary={parseShortDateWithTime(data.appointment.appointmentDateTime)} />
                  </ListItem>
                  {isRioExternalProvider ? (
                    <ListItem key="created date and time">
                      <ListItemText primary="Received at" />
                      <span className="divider" />
                      <ListItemText secondary={parseShortDateWithTime(data.appointment.createdAtDateTime)} />
                    </ListItem>
                  ) : null}
                  <ListItem key="duration">
                    <ListItemText primary="Intended Duration" />
                    <span className="divider" />
                    <ListItemText secondary={data.appointment.intendedDuration} />
                  </ListItem>
                  {isRioExternalProvider ? (
                    <List>
                      <ListItem key="appointment type">
                        <ListItemText primary="Type of appointment" />
                        <span className="divider" />
                        <ListItemText secondary={data.appointment.appointmentType} />
                      </ListItem>
                      <ListItem key="nonClient app">
                        <ListItemText primary="Non client appointment" />
                        <span className="divider" />
                        <ListItemText secondary={data.appointment.nonClientAppointment ? 'Yes' : 'No'} />
                      </ListItem>
                      <ListItem key="location code">
                        <ListItemText primary="Location Code" />
                        <span className="divider" />
                        <ListItemText secondary={data.appointment.locationCode} />
                      </ListItem>
                      <ListItem key="location desc">
                        <ListItemText primary="Location Description" />
                        <span className="divider" />
                        <ListItemText secondary={data.appointment.locationDescription} />
                      </ListItem>
                      <ListItem key="transport status">
                        <ListItemText primary="Transport Status" />
                        <span className="divider" />
                        <ListItemText secondary={data.appointment.transportStatus} />
                      </ListItem>
                      <ListItem key={data.appointment.interpreterStatus}>
                        <ListItemText primary="Interpreter Status" />
                        <span className="divider" />
                        <ListItemText secondary={data.appointment.interpreterStatus} />
                      </ListItem>
                    </List>
                  ) : null}
                </List>
              </div>
              <div className="clinician-info-box">
                <Typography variant="h6" gutterBottom>
                  {locale.getMsg('healthCareProfDetails')}
                </Typography>
                <List className="list-underline">
                  {isRioExternalProvider ? (
                    <List>
                      <ListItem>
                        <ListItemText primary="SDS Type" />
                        <span className="divider" />
                        <ListItemText secondary={data.appointment.healthcareProfessionalValue} />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary="ESR type" />
                        <span className="divider" />
                        <ListItemText secondary={data.appointment.hcpId} />
                      </ListItem>
                    </List>
                  ) : null}
                  {isSystmOneExternalProvider ? (
                    <ListItem>
                      <ListItemText primary="Clinician Username" />
                      <span className="divider" />
                      <ListItemText secondary={data.appointment.clinicianUsername} />
                    </ListItem>
                  ) : null}
                </List>
              </div>
              <div className="clinician-info-box">
                <Typography variant="h6" gutterBottom>
                  {locale.getMsg('associatedVisit')}
                </Typography>
                <List className="list-underline">
                  <ListItem>
                    <ListItemText primary="Id" />
                    <span className="divider" />
                    <ListItemText secondary={data.appointment.visitId} />
                  </ListItem>
                </List>
              </div>
            </div>
          )}
        </div>
      </SwipeableDrawer>
    </section>
  );
}
